// @ts-nocheck
import * as React from "react";

const StarLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m8.85 16.825 3.15-1.9 3.15 1.925-.826-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425-.825 3.575Zm-1.526 2.098 1.24-5.313-4.123-3.571 5.431-.472L12 4.557l2.127 5.01 5.43.472-4.122 3.57 1.24 5.314L12 16.103l-4.675 2.82Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(StarLine);
